import { render, staticRenderFns } from "./ShiftModal.vue?vue&type=template&id=f2c1b87a&scoped=true"
import script from "./ShiftModal.vue?vue&type=script&lang=js"
export * from "./ShiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c1b87a",
  null
  
)

export default component.exports